




















import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class GlpLogo extends Vue {
  @Prop(Boolean) expand!: boolean

  @Prop(String) title!: string

  get collapseCls () {
    return this.expand ? '' : 'glp-logo--collpase'
  }
}
